exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error-section[data-v-1d6ab5e2]{margin-top:.5rem}.error-message[data-v-1d6ab5e2]{text-transform:none}.main-message[data-v-1d6ab5e2]{white-space:pre-line}@media (max-width:768px){h2[data-v-1d6ab5e2]{font-size:24px}h4[data-v-1d6ab5e2]{font-size:20px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1d6ab5e2","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/global-dialogs/ErrorDialog.vue
// module id = 612
// module chunks = 38